import { onLCP, onCLS, onINP } from 'web-vitals';
import type { VitalEntry } from './types';

/**
 * Web vitals from Google's `web-vitals` library — the canonical source. It
 * finalizes LCP at the first user input / page-hide and ignores later entries,
 * so a tab backgrounded during load can NOT report an inflated tens-of-seconds
 * LCP (the artifact a hand-rolled PerformanceObserver, with no visibility guard,
 * used to leak). CLS/INP are reported once at page-hide.
 */
export function captureWebVitals(
  callback: (entry: VitalEntry) => void
): () => void {
  const report = (name: VitalEntry['name'], value: number): void => {
    try {
      callback({ name, value, timestamp: Date.now() });
    } catch {
      // noop
    }
  };

  try {
    onLCP((m) => report('LCP', m.value));
    onCLS((m) => report('CLS', m.value));
    onINP((m) => report('INP', m.value));
  } catch {
    // noop — web-vitals unavailable (very old browser)
  }

  // web-vitals self-manages page-lifecycle listeners and exposes no unsubscribe;
  // each metric fires once when finalized, so there is nothing to disconnect.
  return () => undefined;
}
